export default "__VITE_ASSET__B6sx9nm3__"